module.exports = __webpack_public_path__ + "static/media/kelaibo2.df746d20.png";